/* index.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./index.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import ClockIcon from '@atlaskit/icon/core/clock';
import ChildIssuesIcon from '@atlaskit/icon/core/migration/child-issues';
import { fg } from '@atlaskit/platform-feature-flags';
var rotateSvg = null;

/**
 * ChildIssuesIcon but 180 degrees rotated
 */
var RelatedLinksActionIcon = function RelatedLinksActionIcon() {
  return fg('platform-linking-visual-refresh-v2') ? /*#__PURE__*/React.createElement(ClockIcon, {
    color: "currentColor",
    spacing: "spacious",
    label: "View related links..."
  }) : /*#__PURE__*/React.createElement("span", {
    className: ax(["_t9ec1sub _1e0c1o8l"])
  }, /*#__PURE__*/React.createElement(ChildIssuesIcon, {
    color: "currentColor",
    spacing: "spacious",
    label: "View recent links..."
  }));
};
export default RelatedLinksActionIcon;